import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MerchantService } from 'app/services';
import { MessageService } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmationModalComponent } from './confirmation-modal/confirmation-modal.component';
@Component({
  selector: 'merchant-activation',
  templateUrl: './merchant-activation-component.html',
  styleUrls: ['./merchant-activation-component.scss'],
  providers: [MessageService, DialogService]
})

export class MerchantActivationComponent implements OnInit {
  @Input() merchantId: number = 0;
  public otherEmail!: string;
  public Asap!: string;
  public loading: boolean = false;
  public dateActivatedAt!: Date;
  private ref: DynamicDialogRef | undefined;

  constructor(
    private messageService: MessageService,
    public merchantService: MerchantService,
    private router: Router,
    private dialogService: DialogService
  ) { }

  ngOnInit() {
    this.dateActivatedAt = new Date();
  }
  public confirmMerchant() {
    this.ref = this.dialogService.open(ConfirmationModalComponent, {
      width: '600px',
      contentStyle: { padding: '0' },
      closeOnEscape: true,
      dismissableMask: true,
      data: {
        merchantId: this.merchantId,
        otherEmail: this.otherEmail
      }
    });
  }
  public cancel() {
    this.router.navigate(['home-root'], { skipLocationChange: true });
  }
}
